export const carrierShortName = [
  'vtp',
  'vnp',
  'ghn',
  'ghtk',
  'njv',
  'hbb',
  'kerry',
  'spl',
  'ahm'
]



// WEBPACK FOOTER //
// ./src/stubs/carrier.js